const pushLastFullPageRouteName = ({ commit }, payload) => {
    commit('PUSH_LAST_FULL_PAGE_ROUTE_NAME', payload);
};

export default {
    pushLastFullPageRouteName,
};
